import React from 'react'

import influencerData from '../../data-influencer/dance-works'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const DanceWorks = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default DanceWorks
